import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const GalleryAssetTitle = /*#__PURE__*/ memo((param)=>{
    let { className, clip, ...restOfProps } = param;
    const title = clip.title || clip.importedName || "Untitled";
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: title,
        side: "top",
        sideOffset: 4,
        children: /*#__PURE__*/ _jsx("button", {
            className: tailwindMerge("pointer-events-auto truncate text-left text-16 font-medium text-grey-12 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-blue-9", className),
            ...restOfProps,
            children: title
        })
    });
});
GalleryAssetTitle.displayName = "GalleryAssetTitle";
